import { Component } from '@angular/core';
import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-search-select-input',
    templateUrl: './search-select-input.component.html',
    styleUrls: ['./search-select-input.component.scss'],
    standalone: false
})
export class SearchSelectInputComponent extends BaseFormInput {
}
